// import { Tools } from '@/Services';

import { CustomDate } from './class';

export const create = (date?: number | 'now' | undefined | Date, offset?: number | 'month' | '-month') => new CustomDate(date, offset);
